import { RegionManager } from 'backbone.marionette';

import { MessageCreationView } from '../views/layout';
import { MessagingConfig } from '../models/config';
import { MessageModel } from '../models/message';


module.exports = function (options = {}) {
  const regions = new RegionManager({
    regions: {
      view: '#layout-hook'
    }
  });

  const layout = new MessageCreationView({
    config: new MessagingConfig({
      has_contacts: true,
      has_joinos: true
    }),
    model: new MessageModel(options.model)
  });
  regions.get('view').show(layout);
};



// WEBPACK FOOTER //
// ./messaging/initializers/joinos.js